var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 30.72C24.8366 30.72 32 23.8431 32 15.36C32 6.87691 24.8366 0 16 0C7.16345 0 0 6.87691 0 15.36C0 23.8431 7.16345 30.72 16 30.72Z",
    fill: "#002C43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03295 12.9492H10.7386V25.3305H7.03295V12.9492ZM8.86273 6.66675C9.4573 6.66675 10.0275 6.90178 10.448 7.32014C10.8684 7.7385 11.1046 8.30592 11.1046 8.89757C11.1046 9.48922 10.8684 10.0566 10.448 10.475C10.0275 10.8934 9.4573 11.1284 8.86273 11.1284C7.62726 11.1284 6.66699 10.127 6.66699 8.89757C6.66699 7.66818 7.62726 6.66675 8.86273 6.66675ZM12.9351 12.9492H16.5946V14.6796C16.9825 14.1043 17.5069 13.633 18.1215 13.3074C18.7361 12.9818 19.4218 12.812 20.1181 12.813H21.1244C23.4578 12.813 25.3337 14.7255 25.3337 17.0015V25.3334H21.6741V24.1951V18.6409C21.6287 17.2295 20.6677 16.1363 19.2493 16.1363C17.8308 16.1363 16.6415 17.2287 16.5954 18.6409V25.3334H12.9358L12.9351 12.9492Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.79ecf85155a26e83cd54ae839fd50ea3.svg";
export { ForwardRef as ReactComponent };